import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId
const getNamespace = () => store.state.app.namespace

export default {
  namespaced: true,
  state: {
    deploymentResultInfo: {},
    deployments: [],
    deployment: {},
    fetchingDeployments: false,
    addingDeployment: false,
    removingDeployment: false,
  },
  mutations: {
    SET_DEPLOYMENTS(state, data) {
      state.deployments = data.result
    },
    SET_DEPLOYMENT(state, data) {
      state.deployment = data.result
    },
    SET_FETCHING_DEPLOYMENTS(state, value) {
      state.fetchingDeployments = value
    },
    SET_ADDING_DEPLOYMENT(state, value) {
      state.addingDeployment = value
    },
    SET_REMOVING_DEPLOYMENT(state, value) {
      state.deletingDeployment = value
    },
  },
  actions: {
    fetchDeployments({ commit }) {
      commit('SET_FETCHING_DEPLOYMENTS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/deployments`)
          .then(response => {
            commit('SET_DEPLOYMENTS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_DEPLOYMENTS', false) })
      })
    },
    getDeployment({ commit }, name) {
      commit('SET_FETCHING_DEPLOYMENTS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/deployments/${name}`)
          .then(response => {
            commit('SET_DEPLOYMENT', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_DEPLOYMENTS', false) })
      })
    },
    addDeployment({ commit }, deployment) {
      commit('SET_ADDING_DEPLOYMENT', true)
      return new Promise((resolve, reject) => {
        api('kyubi').post(`projects/${getProjectId()}/namespaces/${getNamespace()}/deployments`, deployment)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_DEPLOYMENT', false) })
      })
    },
    removeDeployment({ commit }, id) {
      commit('SET_REMOVING_DEPLOYMENT', true)
      return new Promise((resolve, reject) => {
        api('kyubi').delete(`projects/${getProjectId()}/namespaces/${getNamespace()}/deployments/${id}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_DEPLOYMENT', false) })
      })
    },
  },
}
